import React, { useEffect, useState, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import LOinfo from "./components/LOinfo/LOinfo.js";
import { CookieSetting } from "cookiesetting-component";
import Home from "./Home.js"
import MortgageGuide from "./components/MortgageGuide.js";


const Footer = lazy(() => import("./components/FooterNew/index.js"));


function App(props) {
  const location = props.location
  const baseName = props.baseName
  const basePath = props.basePath
  const Footer = props.Footer
  return (
    <>
      <Routes>
        <Route exact path="/va-loans/:LOid" element={<LOinfo
          location={location}
          baseName={baseName}
          basePath={basePath}
          Footer={Footer}
        />}>
        </Route>
      </Routes>
      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
      <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    </>
  );
}

export default App;
